(function () {
  const root = document.getElementById('vp-bulk-grid');
  if (!root || root.dataset.vpInitialized === 'true') return;
  root.dataset.vpInitialized = 'true';

  const variants = window.VP_G3000_BULK_VARIANTS || [];
  const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];

  const formatMoney = (value) => '$' + Number(value || 0).toFixed(2);
  const getDiscountRate = (qty) => {
    if (qty >= 48) return 0.20;
    if (qty >= 24) return 0.15;
    if (qty >= 12) return 0.10;
    return 0;
  };

  const colors = [];
  const sizesFound = new Set();
  const variantByColorSize = {};

  variants.forEach((variant) => {
    if (!variant.color || !variant.size) return;
    if (!colors.includes(variant.color)) colors.push(variant.color);
    sizesFound.add(variant.size);
    if (!variantByColorSize[variant.color]) variantByColorSize[variant.color] = {};
    variantByColorSize[variant.color][variant.size] = variant;
  });

  const sizes = sizeOrder.filter((size) => sizesFound.has(size));

  const headerRow = root.querySelector('[data-vp-size-header]');
  const body = root.querySelector('[data-vp-grid-body]');
  const totalQtyEl = root.querySelector('[data-vp-total-qty]');
  const totalPriceEl = root.querySelector('[data-vp-total-price]');
  const discountNoteEl = root.querySelector('[data-vp-discount-note]');
  const messageEl = root.querySelector('[data-vp-message]');
  const customizeBtn = root.querySelector('[data-vp-customize-selected]');
  const clearBtn = root.querySelector('[data-vp-clear]');

  sizes.forEach((size) => {
    const th = document.createElement('th');
    th.textContent = size;
    headerRow.appendChild(th);
  });

  colors.forEach((color) => {
    const tr = document.createElement('tr');
    const firstVariant =
      variantByColorSize[color]['XS'] ||
      variantByColorSize[color]['S'] ||
      variantByColorSize[color]['M'] ||
      sizes.map((size) => variantByColorSize[color][size]).find(Boolean);

    const firstPrice = firstVariant ? Number(firstVariant.price) : 0;
    const firstImage = firstVariant ? firstVariant.image : null;

    const colorTd = document.createElement('td');
    colorTd.className = 'vp-color-cell';

    const colorWrap = document.createElement('div');
    colorWrap.className = 'vp-color-wrap';

    const thumb = document.createElement('div');
    thumb.className = 'vp-shirt-thumb';

    if (firstImage) {
      const img = document.createElement('img');
      img.src = firstImage;
      img.alt = color + ' shirt';
      img.loading = 'lazy';
      thumb.appendChild(img);
    } else {
      const noImage = document.createElement('span');
      noImage.style.fontSize = '11px';
      noImage.style.fontWeight = '800';
      noImage.style.textAlign = 'center';
      noImage.textContent = 'No image';
      thumb.appendChild(noImage);
    }

    const meta = document.createElement('div');
    meta.className = 'vp-color-meta';

    const name = document.createElement('div');
    name.className = 'vp-color-name';
    name.textContent = color;

    const price = document.createElement('div');
    price.className = 'vp-color-price';
    price.textContent = 'From ' + formatMoney(firstPrice);

    const arrow = document.createElement('span');
    arrow.className = 'vp-mobile-arrow';
    arrow.textContent = '⌄';

    meta.appendChild(name);
    meta.appendChild(price);
    colorWrap.appendChild(thumb);
    colorWrap.appendChild(meta);
    colorWrap.appendChild(arrow);
    colorTd.appendChild(colorWrap);
    tr.appendChild(colorTd);

    sizes.forEach((size) => {
      const td = document.createElement('td');
      td.className = 'vp-size-cell';
      td.setAttribute('data-size', size);

      const variant = variantByColorSize[color][size];
      if (variant) {
        const wrap = document.createElement('div');
        wrap.className = 'vp-size-input-wrap';

        const input = document.createElement('input');
        input.className = 'vp-qty-input';
        input.type = 'number';
        input.inputMode = 'numeric';
        input.min = '0';
        input.step = '1';
        input.value = '0';
        input.dataset.variantId = variant.id;
        input.dataset.color = variant.color;
        input.dataset.size = variant.size;
        input.dataset.price = variant.price;
        input.dataset.sku = variant.sku;

        const unit = document.createElement('span');
        unit.className = 'vp-unit-price';
        unit.textContent = formatMoney(variant.price);

        wrap.appendChild(input);
        wrap.appendChild(unit);
        td.appendChild(wrap);
      } else {
        td.textContent = '-';
      }

      tr.appendChild(td);
    });

    colorTd.addEventListener('click', function () {
      if (window.matchMedia('(max-width: 749px)').matches) {
        tr.classList.toggle('vp-open');
      }
    });

    body.appendChild(tr);
  });

  function updateTotals() {
    let totalQty = 0;
    let subtotal = 0;
    const selected = [];

    root.querySelectorAll('.vp-qty-input').forEach((input) => {
      const qty = parseInt(input.value, 10) || 0;
      const price = parseFloat(input.dataset.price) || 0;

      if (qty > 0) {
        totalQty += qty;
        subtotal += qty * price;
        selected.push({
          variant_id: input.dataset.variantId,
          sku: input.dataset.sku,
          color: input.dataset.color,
          size: input.dataset.size,
          quantity: qty,
          base_unit_price: price
        });
      }
    });

    const discountRate = getDiscountRate(totalQty);
    const discountedSubtotal = subtotal - subtotal * discountRate;

    totalQtyEl.textContent = totalQty;
    totalPriceEl.textContent = formatMoney(discountedSubtotal);
    discountNoteEl.textContent = discountRate > 0
      ? Math.round(discountRate * 100) + '% quantity discount applied'
      : 'No quantity discount yet';

    customizeBtn.disabled = totalQty <= 0;
    localStorage.setItem('varaprint_g3000_bulk_selection', JSON.stringify({
      product_handle: 'gildan-3000-unisex-light-cotton-t-shirt',
      total_quantity: totalQty,
      discount_rate: discountRate,
      estimated_shirt_subtotal: discountedSubtotal,
      items: selected
    }));
  }

  root.addEventListener('input', function (event) {
    if (event.target.classList.contains('vp-qty-input')) {
      if (Number(event.target.value) < 0) event.target.value = 0;
      updateTotals();
    }
  });

  clearBtn.addEventListener('click', function () {
    root.querySelectorAll('.vp-qty-input').forEach((input) => input.value = 0);
    root.querySelectorAll('tr.vp-open').forEach((row) => row.classList.remove('vp-open'));
    messageEl.textContent = '';
    updateTotals();
  });

  customizeBtn.addEventListener('click', function () {
    const saved = JSON.parse(localStorage.getItem('varaprint_g3000_bulk_selection') || '{}');
    if (!saved.total_quantity || saved.total_quantity <= 0) {
      messageEl.textContent = 'Enter at least one shirt quantity before customizing.';
      return;
    }

    messageEl.textContent = '';
    const possibleButtons = Array.from(document.querySelectorAll('button, a, input[type="button"], input[type="submit"]'));
    const zakekeButton = possibleButtons.find((el) => {
      const text = String(el.textContent || el.value || '').trim().toLowerCase();
      return text === 'customize' || text.includes('customize');
    });

    if (zakekeButton) {
      zakekeButton.click();
    } else {
      messageEl.textContent = 'Customize button was not found. Keep the Zakeke Customize button visible on this page.';
    }
  });

  updateTotals();
})();
